module.exports = __webpack_public_path__ + "media/images/top/feature_img_01-6964ea2becb1b0a7e4330401f856a11d.png";